import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getVehicleMaintenanceCategories = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VehicleMaintenance}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getVehicleMaintenanceById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VehicleMaintenance}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertVehicleMaintenance = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.VehicleMaintenance,
    input
  );
  return data;
};

const updateVehicleMaintenance = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.VehicleMaintenance,
    input
  );
  return data;
};

const deleteVehicleMaintenance = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.VehicleMaintenance}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useVehicleMaintenanceCategoriesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VehicleMaintenance],
    queryFn: () => getVehicleMaintenanceCategories(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetVehicleMaintenanceByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VehicleMaintenance],
    queryFn: () => getVehicleMaintenanceById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertVehicleMaintenanceMutation = () => {
  return useMutation({
    mutationFn: insertVehicleMaintenance,
  });
};

export const useUpdateVehicleMaintenanceMutation = () => {
  return useMutation({
    mutationFn: updateVehicleMaintenance,
  });
};

export const useDeleteVehicleMaintenanceMutation = () => {
  return useMutation({
    mutationFn: deleteVehicleMaintenance,
  });
};
